var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-clock-in"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-in",
    clipPath: "url(#clip-clock-in)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timer_2_",
    "data-name": "timer (2)",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 14.652, -0.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34381",
    "data-name": "Path 34381",
    d: "M9.625,9.625a1.625,1.625,0,0,0,0-2.3C8.986,6.687,2.34,2.34,2.34,2.34S6.676,8.986,7.316,9.625a1.623,1.623,0,0,0,2.309,0Z",
    transform: "matrix(0.956, 0.292, -0.292, 0.956, 2.508, -2.643)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34382",
    "data-name": "Path 34382",
    d: "M8,0,9,1.59A6.519,6.519,0,1,1,2.466,4.612L1.55,3.29A8,8,0,1,0,8.017,0Z",
    fill: "#5c6d7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIn);
export default __webpack_public_path__ + "static/media/clock-in.4b2d31912c4c22ca98b2465fced52b86.svg";
export { ForwardRef as ReactComponent };